import { Suspense } from "react";
import { RouterProvider } from "react-router/dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { TooltipProvider } from "@pracownik/ui";
import { AuthProvider } from "@/providers/auth-provider";
import { queryClient } from "@/lib/query-client";
import { router } from "@/router";
import { PageSpinner } from "@/components/page-spinner";
import { CookieBanner } from "@/components/cookie-banner";
import { useTheme } from "@/lib/theme";

function ThemedToaster() {
  const { theme } = useTheme();
  return (
    <Toaster
      position="bottom-right"
      theme={theme}
      closeButton
      toastOptions={{
        classNames: {
          toast: "!rounded-xl !border-border !bg-card !text-foreground !shadow-elevated font-sans",
          description: "!text-text-secondary",
          actionButton: "!bg-primary !text-primary-foreground",
        },
      }}
    />
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider delayDuration={300}>
          <Suspense fallback={<PageSpinner />}>
            <RouterProvider router={router} />
          </Suspense>
          <CookieBanner />
          <ThemedToaster />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
